import noLayout from '../../layout/noLayout.vue';
const homeRouter = {
	path: '/',
	component: noLayout,
	redirect: '/',
	name: 'chinese',
	meta: {
		title: '1',
		sort: 4,
	},
	children: [
		{
			path: '/about',
			component: () =>
				import('@/pages/chinese/views/about/newLineAbout.vue'),
			name: 'about',
		},
		//论坛
		{
			path: '/luntan2021',
			component: () => import('@/pages/chinese/views/luntan/2021.vue'),
			name: 'luntan2021',
		},
	],
};

export default homeRouter;
